import { jsx as _jsx } from "react/jsx-runtime";
export function SkipLink({ targetId = 'main' }) {
    return (_jsx("a", { href: `#${targetId}`, className: "sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:bg-white focus:text-brand-700 focus:px-4 focus:py-2 focus:rounded focus:shadow focus:outline-none focus:ring-2 focus:ring-brand-500", children: "Skip to main content" }));
}
